import { useTheme } from "../../context/ThemeContext";
import { getAppTheme } from "../../config/resolve-app-brand";
import { useState } from "react";
import { Divider, Drawer, List, ListItem, ListItemText, Collapse, Typography } from "@mui/material";
import { createSessionForExternal } from "../../utils/common";
import { IconButton, Box } from "@mui/material";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { ReactComponent as SwitchBusinessIcon } from "../../assets/switch-account-icon.svg";
import { ReactComponent as LogOutIcon } from "../../assets/log-out-icon.svg";
import { ReactComponent as AddIcon } from "../../assets/add.svg";

import { useNavigate, useParams } from "react-router-dom";

import {
  FavouritesIcon,
  PayrollIcon,
  BusinessIcon,
  ReportsIcon,
  FinanceIcon,
} from "../MainNavigation/NavigationIcons";

import ThemeToggle from "../ThemeToggle/ThemeToggle";
import { getCookie } from "../../utils/api";
import envConfig from "../../config";

const MobileMenuSection = ({
  icon = {},
  handleMenuClick = () => {},
  open,
  setOpen = () => {},
  companyName = "",
  currentMenuItem = "",
  urlPrefix = "",
  //
  mainMenuTitle = "",
  sectionOne = [],
  sectionOneTitle = "",
  sectionOneExtra = [],
  //
  sectionTwo = [],
  sectionTwoTitle = "",
  sectionTwoExtra = [],
  //
  sectionThree = [],
  sectionThreeTitle = "",
  sectionThreeExtra = [],
  //
  isCompanyTile,
  sectionFour = [],
  sectionFourTitle = "",
  sectionFourExtra = [],
}) => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();
  const theme = getAppTheme(isDarkMode);
  const [expanded, setExpanded] = useState(false);

  const hasSubItems = sectionOne?.length > 0 || sectionTwo?.length > 0 || 
                     sectionThree?.length > 0 || sectionFour?.length > 0;

  const handleItemClick = () => {
    if (hasSubItems) {
      setExpanded(!expanded);
      handleMenuClick(mainMenuTitle);
    }
  };

  const renderMenuItems = (items, extraItems, title) => (
    <>
      {items?.length > 0 && currentMenuItem === mainMenuTitle && (
        <List sx={{ padding: 0, margin: 0 }}>
          {items.map(
            (subpage, subIndex) =>
              (companyName !== "My Profile" ||
                subpage.type === "my_profile") && (
                <div key={subIndex}>
                  {subpage.Label && subpage.type !== "quick_link" && (
                    <ListItem
                      onClick={() => {
                        if (subpage.Hyperlink) {
                          if (subpage.Hyperlink.startsWith("http")) {
                            createSessionForExternal(subpage.Hyperlink);
                            setOpen(false);
                          } else {
                            navigate(`${subpage.Hyperlink}`, { replace: true });
                            setOpen(false);
                          }
                        }
                      }}
                      sx={{
                        cursor: "pointer",
                        paddingLeft: "72px",
                        position: "relative",
                        userSelect: "none",
                        "&::before": {
                          content: '""',
                          position: "absolute",
                          left: "33px",
                          top: 0,
                          bottom: 0,
                          width: "1px",
                          backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.87)" : "#757575",
                        },
                        "&:hover": {
                          backgroundColor: theme.palette.action.hover,
                        },
                      }}
                    >
                      <ListItemText
                        disableRipple
                        sx={{
                          span: {
                            color: isDarkMode ? "rgba(255, 255, 255, 0.87)" : "#757575",
                            fontFamily: "Inter",
                            fontSize: "20px",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "150%",
                            letterSpacing: "-0.264px",
                            "&:hover": {
                              color: theme.palette.primary.main,
                            },
                          },
                        }}
                        primary={subpage.Label}
                      />
                    </ListItem>
                  )}
                </div>
              )
          )}
          {extraItems?.map((extra, extraIndex) => (
            <ListItem
              key={extraIndex}
              onClick={(e) => {
                e.stopPropagation();
                if (extra.Hyperlink) {
                  if (extra.Hyperlink.startsWith("http")) {
                    createSessionForExternal(extra.Hyperlink);
                    setOpen(false);
                  } else {
                    navigate(`${extra.Hyperlink}`, { replace: true });
                    setOpen(false);
                  }
                }
              }}
              sx={{
                cursor: "pointer",
                paddingY: "12px",
                paddingLeft: "72px",
                position: "relative",
                userSelect: "none",
                color: theme.palette.secondary.main,
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: "33px",
                  top: 0,
                  bottom: 0,
                  width: "1px",
                  backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.87)" : "#757575",
                },
                "&:hover": {
                  backgroundColor: theme.palette.action.hover,
                  color: theme.palette.primary.main,
                },
              }}
            >
              {extra?.Icon === "plus" && (
                <AddIcon
                  width={12}
                  height={12}
                  style={{
                    marginRight: "10px",
                  }}
                />
              )}
              <Typography
                sx={{
                  color: 'inherit',
                  fontFamily: "Inter",
                  fontSize: "20px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "150%",
                  letterSpacing: "-0.264px",
                }}
              >
                {extra?.Label}
              </Typography>
            </ListItem>
          ))}
        </List>
      )}
    </>
  );

  const menuItemStyles = {
    cursor: "pointer",
    paddingY: "16px",
    paddingX: "24px",
    userSelect: "none",
    display: "flex",
    alignItems: "center",
    mb: isCompanyTile ? -1 : 0,
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  };

  const firstLevelTextStyles = {
    color: isDarkMode ? "rgba(255, 255, 255, 0.87)" : "#757575",
    fontFamily: "Inter",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: isCompanyTile && mainMenuTitle ? 700 : 400,
    lineHeight: "150%",
    letterSpacing: "-0.264px",
    flexGrow: 1,
  };

  return (
    <div>
      {(hasSubItems || isCompanyTile) && (
        <ListItem onClick={handleItemClick} sx={menuItemStyles}>
          {icon && (
            <Box
              sx={{
                marginRight: "18px",
                minWidth: "30px",
                display: "flex",
                alignItems: "center",
                color: "#757575",
                "& svg": {
                  stroke: "currentColor",
                },
              }}
            >
              {!isCompanyTile && icon}
              {isCompanyTile && (
                <>
                  <span
                    style={{
                      textTransform: "uppercase",
                      color: theme.palette.primary.main,
                      fontSize: "9px",
                      top: "-6px",
                      width: "max-content",
                      position: "absolute",
                      left: "50%",
                      transform: "translateX(-50%)",
                    }}
                  >
                    {mainMenuTitle}
                  </span>
                </>
              )}
            </Box>
          )}

          <Typography sx={{...firstLevelTextStyles}}>
            {isCompanyTile ? (
              <>
                <span style={{ fontSize: "12px", display: "block", lineHeight: 1 }}>
                  Manage
                </span>
                <span style={{ color: theme.palette.primary.main, fontWeight: 700 }}>
                  {mainMenuTitle}
                </span>
              </>
            ) : (
              mainMenuTitle
            )}
          </Typography>

          {hasSubItems && (
            <Box sx={{ color: isDarkMode ? "rgba(255, 255, 255, 0.87)" : "#757575" }}>
              {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </Box>
          )}
        </ListItem>
      )}

      <Collapse in={expanded && currentMenuItem === mainMenuTitle} timeout="auto" unmountOnExit>
        {renderMenuItems(sectionOne, sectionOneExtra, sectionOneTitle)}
        {renderMenuItems(sectionTwo, sectionTwoExtra, sectionTwoTitle)}
        {renderMenuItems(sectionThree, sectionThreeExtra, sectionThreeTitle)}
        {renderMenuItems(sectionFour, sectionFourExtra, sectionFourTitle)}
      </Collapse>
    </div>
  );
};

const MobileNavigation = ({ ip, newMenuItems, urlPrefix }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [currentMenuItem, setCurrentMenuItem] = useState(null);
  const { dbId } = useParams();
  const { isDarkMode } = useTheme();
  const theme = getAppTheme(isDarkMode);

  const handleMenuToggle = () => {
    setOpen(!open);
  };

  const handleMenuClick = (label) => {
    if (label === currentMenuItem) {
      setCurrentMenuItem(null);
      return;
    }
    setCurrentMenuItem(label);
  };

  const handleSwitchBusiness = () => {
    navigate("/user-dashboard", { replace: true });
  };

  const handleLogOut = () => {
    window.location = `https://${envConfig.loginUrl}/logout`;
  };

  return (
    <>
      <IconButton
        color="inherit"
        onClick={handleMenuToggle}
        data-testid="mobile-navigation--IconButton-0">
        {open ? <CloseIcon /> : <MenuOutlinedIcon />}
      </IconButton>
      <Drawer
        sx={{ zIndex: 9999999999 }}
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
      >
        <List
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            minWidth: "414px",
            position: "relative",
            pt: 7
          }}
        >
          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              top: 24,
              right: 16,
              zIndex: 1,
              color: theme.palette.secondary.main,
              "&:hover": {
                color: theme.palette.primary.main,
              },
            }}
            data-testid="mobile-navigation--IconButton-1">
            <CloseIcon />
          </IconButton>
          <Box
            sx={{
              flexGrow: 1,
              overflowY: "auto",
            }}
          >
            <MobileMenuSection
              ip={ip}
              icon={
                <FavouritesIcon
                  width={24}
                  height={24}
                  style={{ marginLeft: "2px" }}
                />
              }
              handleMenuClick={handleMenuClick}
              open={open}
              setOpen={setOpen}
              companyName={newMenuItems?.BusinessCode}
              currentMenuItem={currentMenuItem}
              urlPrefix={urlPrefix}
              //
              mainMenuTitle="Favorites"
              sectionOneTitle="Favorites"
              sectionOne={newMenuItems?.Me_QuickLinks}
            />
            <MobileMenuSection
              ip={ip}
              icon={
                <PayrollIcon
                  width={24}
                  height={24}
                  style={{ marginLeft: "2px" }}
                />
              }
              handleMenuClick={handleMenuClick}
              open={open}
              setOpen={setOpen}
              companyName={newMenuItems?.BusinessCode}
              currentMenuItem={currentMenuItem}
              urlPrefix={urlPrefix}
              //
              mainMenuTitle="Payroll"
              sectionOne={newMenuItems?.Payroll_Payroll_Links}
              sectionOneTitle="Payroll"
              sectionOneExtra={newMenuItems?.Payroll_Payroll_Extras}
              sectionTwo={newMenuItems?.Payroll_Rosters_Links}
              sectionTwoTitle="Rosters"
              sectionTwoExtra={newMenuItems?.Payroll_Rosters_Extras}
              sectionThree={newMenuItems?.Payroll_Timesheet_Links}
              sectionThreeTitle="Timesheet"
              sectionThreeExtra={newMenuItems?.Payroll_Timesheet_Extras}
            />
            <MobileMenuSection
              ip={ip}
              icon={
                <BusinessIcon
                  width={23}
                  height={24}
                  style={{ marginLeft: "3px" }}
                />
              }
              handleMenuClick={handleMenuClick}
              open={open}
              setOpen={setOpen}
              companyName={newMenuItems?.BusinessCode}
              currentMenuItem={currentMenuItem}
              urlPrefix={urlPrefix}
              //
              mainMenuTitle="Business"
              sectionOne={newMenuItems?.Contacts_Links}
              sectionOneTitle="Contacts"
              sectionOneExtra={newMenuItems?.Contacts_Extras}
              sectionTwo={newMenuItems?.Invoices_Purchases_Links}
              sectionTwoTitle="Purchases"
              sectionTwoExtra={newMenuItems?.Invoices_Purchases_Extras}
              sectionThree={newMenuItems?.Invoices_Sales_Links}
              sectionThreeTitle="Sales"
              sectionThreeExtra={newMenuItems?.Invoices_Sales_Extras}
            />

            <MobileMenuSection
              ip={ip}
              icon={
                <FinanceIcon
                  style={{ marginBottom: "-3px" }}
                  width={30}
                  height={30}
                />
              }
              handleMenuClick={handleMenuClick}
              open={open}
              setOpen={setOpen}
              companyName={newMenuItems?.BusinessCode}
              currentMenuItem={currentMenuItem}
              urlPrefix={urlPrefix}
              //
              mainMenuTitle="Finance"
              sectionOneTitle="Accounting"
              sectionOne={newMenuItems?.Accounting_Links}
              sectionOneExtra={newMenuItems?.Accounting_Extras}
              sectionTwoTitle="Banking"
              sectionTwo={newMenuItems?.Accounting_Banking_Links}
              sectionTwoExtra={newMenuItems?.Accounting_Banking_Extras}
            />
            <MobileMenuSection
              ip={ip}
              icon={<ReportsIcon width={28} height={28} />}
              handleMenuClick={handleMenuClick}
              open={open}
              setOpen={setOpen}
              companyName={newMenuItems?.BusinessCode}
              currentMenuItem={currentMenuItem}
              urlPrefix={urlPrefix}
              //
              mainMenuTitle="Reports"
              sectionOne={newMenuItems?.Reports}
            />

            <MobileMenuSection
              ip={ip}
              icon={<></>}
              handleMenuClick={handleMenuClick}
              open={open}
              setOpen={setOpen}
              mainMenuTitle={newMenuItems?.BusinessCode}
              companyName={newMenuItems?.BusinessCode}
              currentMenuItem={currentMenuItem}
              urlPrefix={urlPrefix}
              isCompanyTile={true}
              sectionOne={
                newMenuItems?.Me_Configuration?.length
                  ? newMenuItems?.Me_Configuration
                  : newMenuItems.Subscribers
              }
              sectionOneTitle={
                newMenuItems?.Me_Configuration?.length
                  ? "Configuration"
                  : "Subscribers"
              }
              sectionOneExtra={newMenuItems?.Subscribers_Extra}
              sectionTwo={newMenuItems?.Me_MyProfile}
              sectionTwoTitle="My Profile"
              sectionFour={
                newMenuItems?.Me_Users?.length
                  ? newMenuItems?.Me_Users
                  : newMenuItems?.GlobalProfile
              }
              sectionFourTitle={
                newMenuItems?.Me_Users?.length ? "Users" : "My Profile"
              }
            />
          </Box>
          
          <Divider sx={{ marginY: 2 }} />

          {/* Bottom section with updated styles from olivs-client */}
          <Box sx={{ paddingX: "24px", paddingBottom: "24px", color: theme.palette.secondary.main }}>
            {/* Row 1: Switch and Log out */}
            <Box
              sx={{
                display: "flex",
                gap: 2,
                marginBottom: 2,
              }}
            >
              <Box
                onClick={handleSwitchBusiness}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 2,
                  alignItems: "center",
                  cursor: "pointer",
                  flex: 1,
                  justifyContent: 'center',
                  "&:hover": {
                    color: theme.palette.primary.main,
                    "& svg": {
                      stroke: theme.palette.primary.main,
                    },
                  },
                }}
                data-testid="mobile-navigation--Box-0">
                <SwitchBusinessIcon width={32} height={32} />
                <Typography
                  sx={{
                    fontSize: "14px",
                    marginTop: "4px",
                    fontWeight: 700,
                    fontFamily: "Inter",
                    color: 'inherit',
                  }}
                >
                  Switch
                </Typography>
              </Box>
              <Box
                onClick={handleLogOut}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  cursor: "pointer",
                  gap: 2,
                  flex: 1,
                  justifyContent: 'center',
                  "&:hover": {
                    color: theme.palette.primary.main,
                    "& svg": {
                      stroke: theme.palette.primary.main,
                    },
                  },
                }}
                data-testid="mobile-navigation--Box-1">
                <LogOutIcon width={32} height={32} />
                <Typography
                  sx={{
                    fontSize: "14px",
                    marginTop: "4px",
                    fontWeight: 700,
                    fontFamily: "Inter",
                    color: 'inherit',
                  }}
                >
                  Log out
                </Typography>
              </Box>
            </Box>

            {/* Row 2: Theme toggle */}
            <Box
              sx={{
                display: "flex",
                gap: 2,
                mt: 4,
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  flex: 1,
                }}
              >
                <ThemeToggle titlefontSize={14} title="" showTitle={false} />
              </Box>
            </Box>
          </Box>
        </List>
      </Drawer>
    </>
  );
};

export default MobileNavigation;